import React from 'react';
import {
  Container,
  Grid,
  Paper,
  Typography,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

const plans = [
  {
    title: 'Basic',
    price: 'SAR 99',
    period: '/month',
    features: [
      'Up to 100 invoices per month',
      'Basic ZATCA compliance',
      'Email support',
      'Basic reporting',
    ],
    buttonText: 'Get Started',
    current: false,
  },
  {
    title: 'Professional',
    price: 'SAR 199',
    period: '/month',
    features: [
      'Up to 500 invoices per month',
      'Advanced ZATCA compliance',
      'Priority email & phone support',
      'Advanced reporting',
      'Multiple users',
      'API access',
    ],
    buttonText: 'Upgrade Now',
    current: true,
    highlighted: true,
  },
  {
    title: 'Enterprise',
    price: 'SAR 399',
    period: '/month',
    features: [
      'Unlimited invoices',
      'Full ZATCA compliance',
      '24/7 priority support',
      'Custom reporting',
      'Unlimited users',
      'API access',
      'Custom integration',
    ],
    buttonText: 'Contact Sales',
    current: false,
  },
];

function Subscription() {
  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom>
        Subscription Plans
      </Typography>
      
      <Grid container spacing={4} sx={{ mt: 2 }}>
        {plans.map((plan) => (
          <Grid item xs={12} md={4} key={plan.title}>
            <Paper
              sx={{
                p: 4,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                ...(plan.highlighted && {
                  border: (theme) => `2px solid ${theme.palette.primary.main}`,
                  transform: 'scale(1.02)',
                }),
              }}
            >
              {plan.highlighted && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 12,
                    right: 12,
                    bgcolor: 'primary.main',
                    color: 'white',
                    px: 2,
                    py: 0.5,
                    borderRadius: 1,
                  }}
                >
                  Popular
                </Box>
              )}
              
              <Typography variant="h5" component="h2" gutterBottom>
                {plan.title}
              </Typography>
              
              <Box sx={{ mb: 2 }}>
                <Typography variant="h3" component="span">
                  {plan.price}
                </Typography>
                <Typography variant="subtitle1" component="span" color="text.secondary">
                  {plan.period}
                </Typography>
              </Box>

              <List sx={{ mb: 2, flexGrow: 1 }}>
                {plan.features.map((feature) => (
                  <ListItem key={feature} disableGutters>
                    <ListItemIcon sx={{ minWidth: 36 }}>
                      <CheckIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText primary={feature} />
                  </ListItem>
                ))}
              </List>

              <Button
                variant={plan.current ? 'outlined' : 'contained'}
                fullWidth
                size="large"
                disabled={plan.current}
              >
                {plan.current ? 'Current Plan' : plan.buttonText}
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 4, mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          Current Subscription
        </Typography>
        <Typography variant="body1" paragraph>
          You are currently on the Professional plan. Your next billing date is April 25, 2024.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Need help? Contact our support team at support@zatcainvoice.com
        </Typography>
      </Paper>
    </Container>
  );
}

export default Subscription; 